import React, { Component } from 'react';
import { createMuiTheme, MuiThemeProvider } from 'material-ui/styles';
import { Redirect, Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import MainApp from 'app/index';
import 'react-big-calendar/lib/less/styles.less';
import 'styles/bootstrap.scss'
import 'styles/app.scss';
import defaultTheme from './themes/defaultTheme';
import ReduxToastr from 'react-redux-toastr'
import Footer from 'components/Footer';

import DevTools from '../store/DevTools';
import Login from '../app/login'

//auth
import {
    userIsAuthenticatedRedir, userIsNotAuthenticatedRedir, userIsBoardAdminRedir,
    userIsAuthenticated, userIsNotAuthenticated
} from '../app/auth'
class App extends Component {

    render() {
        const { match, location } = this.props;
        const LoginNotProtected = withRouter(userIsNotAuthenticatedRedir(Login))
        const MainAppProtected = userIsAuthenticatedRedir(MainApp)

        // if (location.pathname === '/') {
        //     return (<Redirect to={'/dashboard'} />);
        // }

        if (location.pathname === '/login' || location.pathname.indexOf('/login/') === 0 || location.pathname.indexOf('/login#/') === 0) {
            return (
                <MuiThemeProvider theme={createMuiTheme(defaultTheme)}>
                    <div className="app-main">
                        <div className="app-main-container">
                            <main className="app-main-content-wrapper">
                                <div className="app-main-content">
                                    <Route path={`${match.url}login`} component={LoginNotProtected} />
                                </div>
                                <Footer />
                            </main>
                        </div>
                        <ReduxToastr
                            timeOut={4000}
                            newestOnTop={false}
                            preventDuplicates
                            position="top-right"
                            transitionIn="fadeIn"
                            transitionOut="fadeOut"
                            progressBar />
                        {(() => {
                            if (process.env.NODE_ENV === 'development')
                                return <DevTools />
                        })()}
                    </div>
                </MuiThemeProvider>
            );
        }
        return (
            <MuiThemeProvider theme={createMuiTheme(defaultTheme)}>
                <div className="app-main">
                    <Route path={`${match.url}`} component={MainAppProtected} />
                    <ReduxToastr
                        timeOut={4000}
                        newestOnTop={false}
                        preventDuplicates
                        position="top-right"
                        transitionIn="fadeIn"
                        transitionOut="fadeOut"
                        progressBar />
                    {(() => {
                        if (process.env.NODE_ENV === 'development')
                            return <DevTools />
                    })()}
                </div>
            </MuiThemeProvider>
        );
    }
}

const mapStateToProps = ({ settings }) => {
    const { sideNavColor } = settings;
    return { sideNavColor }
};

export default withRouter(connect(mapStateToProps)(App));





// WEBPACK FOOTER //
// ./containers/App.js